import Vue from 'vue'
import VueRouter from 'vue-router'
import Landing from '../views/Landing.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    props: route => ({
      galleryHash: route.hash === '#gallery'
    }),
    // Video hero, parallax, gallery
    component: Landing
  },
  {
    path: '/upload',
    // Upload, crop
    component: () => import('@/views/UploadAvatar.vue')
  },
  {
    path: '/create',
    // Stitch, quote, position
    component: () => import('@/views/PositionAvatar.vue')
  },
  {
    path: '/card/:id?',
    props: route => ({
      id: route.params.id,
      share: 'share' in route.query
    }),
    component: () => import('@/views/ShareCard.vue')
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to) {
    let top = 0
    if (to.hash) {
      const element = document.querySelector(to.hash)
      top = element ? element.offsetTop : top
      return window.scrollTo({
        top,
        behavior: 'smooth'
      })
    }
    return { x: 0, y: 0 }
  }
})

export default router
